import React from "react";

function DailyReportIcon({fill}) {
  return (
    <>
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5 1.875C8.89303 1.875 7.32214 2.35152 5.986 3.24431C4.64985 4.1371 3.60844 5.40605 2.99348 6.8907C2.37852 8.37535 2.21762 10.009 2.53112 11.5851C2.84463 13.1612 3.61846 14.6089 4.75476 15.7452C5.89106 16.8815 7.3388 17.6554 8.9149 17.9689C10.491 18.2824 12.1247 18.1215 13.6093 17.5065C15.094 16.8916 16.3629 15.8502 17.2557 14.514C18.1485 13.1779 18.625 11.607 18.625 10C18.6227 7.84581 17.766 5.78051 16.2427 4.25727C14.7195 2.73403 12.6542 1.87727 10.5 1.875ZM16.1148 6.03672L11.125 8.91719V3.15391C12.1158 3.24474 13.0751 3.54954 13.9366 4.04726C14.7981 4.54498 15.5413 5.22376 16.1148 6.03672ZM9.875 3.15391V9.63828L4.2586 12.8805C3.79753 11.8811 3.58313 10.7857 3.6334 9.68628C3.68368 8.58685 3.99716 7.51556 4.54751 6.56247C5.09785 5.60938 5.86896 4.80234 6.79603 4.2092C7.72309 3.61606 8.77901 3.25415 9.875 3.15391ZM10.5 16.875C9.39937 16.8745 8.31493 16.6099 7.33786 16.1032C6.36079 15.5965 5.51965 14.8626 4.88516 13.9633L16.7414 7.11875C17.2249 8.16621 17.437 9.3185 17.3582 10.4695C17.2795 11.6204 16.9123 12.7331 16.2906 13.7049C15.6689 14.6767 14.8126 15.4765 13.8007 16.0305C12.7888 16.5844 11.6537 16.8749 10.5 16.875Z"
          fill={fill}
        />
      </svg>
    </>
  );
}

export default DailyReportIcon;
